export const FEATURE_MANAGER_IDENTIFIER_PREFIX = '.appconfig.featureflag/';
export const HTTP_ERRORRESPONSE_RNA_SSN_DUP_CHECK_ERROR = 'Unable to verify SSN due to issues connecting with our services, please try again';